import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function InventoryFooter({ children }: Props) {
  return (
    <div className="shrink-0 px-7.5 h-[4.875rem] flex items-center justify-between border-t border-[#191919]">
      {children}
    </div>
  );
}
